document.querySelector(".share-btn").addEventListener('click',()=>{
  document.querySelector(".share_popup_maim_container.custom_popup").classList.add("show");
 document.querySelector("body").classList.add("overflow-hidden");
})
 document.querySelectorAll(".click_to_copy").forEach(function(element) {
  element.addEventListener('click', function(event) {
    event.preventDefault();
    let link = this.dataset.url;
    navigator.clipboard.writeText(link);
    this.querySelector(".share-icon").style.backgroundColor = "#ea5b29";
    this.querySelector(".share-text").textContent = "Copied";
  });
});

document.querySelector(".custom_popup_close").addEventListener('click', () => {
  document.querySelector(".share_popup_maim_container.custom_popup").classList.remove("show");
  document.querySelector("body").classList.remove("overflow-hidden");
});